import clsx from 'clsx';
import { ComponentSize } from '../../../types';
import { TypographyComponent } from '../Typography';
import { TOGGLE_SIZE_TO_CLASSNAME } from './Toggle.constants';
import { ToggleProps } from './Toggle.types';

const Toggle = ({ leftLabel, rightLabel, onChange, checked, size = ComponentSize.SMALL }: ToggleProps) => {
  const renderLabel = (label?: string | TypographyComponent) =>
    typeof label === 'string' ? <span className="label-text">{label}</span> : label;

  return (
    <label className={clsx('label flex cursor-pointer items-center gap-2 p-0', !leftLabel && !rightLabel && 'w-fit')}>
      {leftLabel && renderLabel(leftLabel)}
      <input
        type="checkbox"
        className={clsx(
          'toggle border-base-300 checked:bg-base-content/80 hover:checked:bg-base-content/80 [--tglbg:theme(colors.gray.700)]',
          leftLabel && rightLabel ? 'bg-base-content/80 hover:bg-base-content/80' : 'bg-base-200 hover:bg-base-200',
          TOGGLE_SIZE_TO_CLASSNAME[size]
        )}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
      />
      {rightLabel && renderLabel(rightLabel)}
    </label>
  );
};

export default Toggle;
